// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React, { createContext, useState } from "react";

export interface CategoryDetailsContextData {
    hasSubcategories: boolean;
    setHasSubCategories: (value: boolean) => void;
}

const categoryDetailsContextData: CategoryDetailsContextData = {
    hasSubcategories: false,
    setHasSubCategories: (value: boolean) => {},
};

export const CategoryDetailsContext = createContext<CategoryDetailsContextData>(categoryDetailsContextData);

const CategoryDetailsContextProvider: React.FC = ({ children }) => {
    const [hasSubcategories, setHasSubCategories] = useState(false);
    return (
        <CategoryDetailsContext.Provider
            value={{
                hasSubcategories,
                setHasSubCategories,
            }}
        >
            {children}
        </CategoryDetailsContext.Provider>
    );
};

export default CategoryDetailsContextProvider;
